import React from 'react';
import { Link, useHistory } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import { useState } from "react";



const Header = () =>{
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const currentRoute = useHistory().location.pathname.toLowerCase();

  return(
    <>
    <div className='top-space'></div>
<nav className="header-1 navbar navbar-expand-lg navbar-light d-flex justify-content-center bg-transparent fixed-top">
<div className="container-fluid w-100 px-5">
  <div className="logo_wrap">
    <Link className="navbar-brand m-0 p-0" to="/"><img className='site-logo' src="..\assets\images\logo.png"/> </Link>
    </div>
      <ul className="navbar-nav me-auto mb-2 mb-lg-0 d-flex justify-content-center w-100">
        <li className="nav-item">
          <Link className={currentRoute.includes("/") ? "nav-link active" : "nav-link"} 
        
          aria-current="page" to="./">Home</Link>
        </li>
        <li className="nav-item">
          <Link className={currentRoute.includes("/aboutus") ? "nav-link active" : "nav-link"} 
          to="/aboutus">About Us</Link>
        </li>
        <li className="nav-item me-0"   onClick={() => {setShow(true)}}>
            <Link className={currentRoute.includes("#") ? "nav-link active" : "nav-link"}  as={Link} to="#">How It Works</Link>
          </li>
      </ul>

      <Link to="/login" className="sign me-3">Sign In</Link>
      <Link to="/register" className="sign">Sign Up</Link>

    </div>
   
</nav>
<Modal show={show} onHide={handleClose} className='SubmitPopup howitworks'>
        <Modal.Header closeButton className='justify-content-center border-0'>
          <Modal.Title><h2 className="h2_medum fw-bold text-center pt-4 mb-0" >How It<span className='color-9F7854 user-name fw-bold'> Works</span></h2></Modal.Title>
        </Modal.Header>
        <Modal.Body>
                <ul className='mb-0'>
                    <li>At KBD, you can list a business or request a business listing. </li>
                    <li>The first step is to sign up for the platform. </li>
                    <li>The platform requires proof of identity from its members, which the admin verifies.</li>
                    <li>For further verification, you are requested to add two community references. </li>
                    <li>Once you are approved, you can now list a business and request a business listing in up to 3 categories. </li>
                    <li>All requests, including signup, listing a business, and requesting a listing, are verified and approved by an admin. </li>
                </ul>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "center"}} className="text-center pb-5">
        Sign up  <span>{">"}</span>  Get approved by the admin  <span>{">"}</span>  Sign in  <span>{">"}</span>  List a business  <span>{">"}</span>  Approved by admin and added to the directory  <span>{">"}</span> Request a business listing  <span>{">"}</span>  Approved by admin and listing emailed to the member
        </Modal.Footer>
</Modal>
</>
  )}
export default Header;